import { Stack } from '@chakra-ui/react'
import { UseFormReturn } from 'react-hook-form'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import HourFieldWithValidator from './components/HourFieldWithValidator'

type Props = {
  formMethods: UseFormReturn<CustomFormQuestion>
}

export default function HourValidators({ formMethods }: Props) {
  return (
    <Stack>
      <HourFieldWithValidator formMethods={formMethods} label="Horário mínimo" registerKey="validation.min" />
      <HourFieldWithValidator formMethods={formMethods} label="Horário máximo" registerKey="validation.max" />
    </Stack>
  )
}
